import { Row } from 'react-table';
import { TableRow } from './TableRow';
import { TableLoadingRow } from './TableLoadingRow';

type TableBodyProps<T extends object> = {
  getTableBodyProps: () => Record<string, any>;
  rows: Row<T>[];
  prepareRow: (row: Row<T>) => void;
  isLoading?: boolean;
  colSpan?: number;
  className?: string;
};

export const TableBody = <T extends object>({
  getTableBodyProps,
  rows,
  prepareRow,
  isLoading = false,
  colSpan = 7,
  className = 'text-gray-800',
}: TableBodyProps<T>) => {
  return (
    <tbody className={className} {...getTableBodyProps()}>
      {rows.length > 0 ? (
        rows.map((row) => {
          prepareRow(row);
          // Let row.getRowProps() manage the unique key internally inside TableRow,
          // or pass row.id directly instead of combining array index `i`
          return <TableRow key={row.id} row={row} />;
        })
      ) : (
        <TableLoadingRow colSpan={colSpan} isLoading={isLoading} noMatchText='No information available.'/>
      )}
    </tbody>
  );
};